<template>
  <div class="match-home page-max-width">
    <MatchHeroNav />
    <MatchNewsSection />
    <MatchProgressSection />
    <MatchVideoCenter />
    <MatchFollowSection />
    <MatchPageFooter />
  </div>
</template>

<script>
import MatchHeroNav from '@/components/match/home/MatchHeroNav.vue'
import MatchNewsSection from '@/components/match/home/MatchNewsSection.vue'
import MatchProgressSection from '@/components/match/home/MatchProgressSection.vue'
import MatchVideoCenter from '@/components/match/home/MatchVideoCenter.vue'
import MatchFollowSection from '@/components/match/home/MatchFollowSection.vue'
import MatchPageFooter from '@/components/match/common/MatchPageFooter.vue'

export default {
  name: 'MatchHome',
  components: {
    MatchPageFooter,
    MatchHeroNav,
    MatchNewsSection,
    MatchProgressSection,
    MatchVideoCenter,
    MatchFollowSection,
  },
}
</script>

<style lang="scss" scoped>
.match-home {
  min-height: 100vh;
  background: #f3f1ee;

  @media (max-width: 750px) {
    background: #f3f1ee url('@/assets/image/match/pc/match/1.jpg') center top / 100% auto no-repeat;
  }
}
</style>
